import { openBlock as t, createElementBlock as a, normalizeClass as i, createElementVNode as o } from "vue";
/* empty css                            */
import r from "../../../_virtual/_plugin-vue_export-helper.js";
const s = {
  name: "DsHeaderNavigationIcon",
  props: {
    active: { type: Boolean, required: !0 }
  },
  data: () => ({
    mode: null
    // no animation on page load
  }),
  watch: {
    active(e) {
      this.mode ? this.mode = e ? "enter" : "leave" : this.mode = "enter";
    }
  }
};
function l(e, n, d, c, p, m) {
  return t(), a("svg", {
    width: "22",
    height: "18",
    viewbox: "0 0 22 18",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: i(`ds-header-navigation-icon ds-header-navigation-icon--animation-${e.mode}`)
  }, n[0] || (n[0] = [
    o("path", {
      d: "M1 1H19",
      class: "line1"
    }, null, -1),
    o("path", {
      d: "M1 8H19",
      class: "line2"
    }, null, -1),
    o("path", {
      d: "M1 15H19",
      class: "line3"
    }, null, -1)
  ]), 2);
}
const v = /* @__PURE__ */ r(s, [["render", l]]);
export {
  v as default
};
